// One-time risk acknowledgement gate for free Telegram links.
const KEY = "tq_risk_ack";

export const hasRiskConsent = () => {
  try {
    return !!localStorage.getItem(KEY);
  } catch {
    return false;
  }
};

export const setRiskConsent = () => {
  try {
    localStorage.setItem(KEY, new Date().toISOString());
  } catch {
    /* ignore */
  }
};

let opener = null;
export const registerRiskGate = (fn) => {
  opener = fn;
};

const openUrl = (url) => window.open(url, "_blank", "noopener,noreferrer");

// Call from any Telegram CTA. Opens directly if already acknowledged,
// otherwise shows the acknowledgement modal and opens on accept.
export const requestTelegram = (url) => {
  if (hasRiskConsent()) {
    openUrl(url);
    return;
  }
  if (opener) opener(url, openUrl);
  else openUrl(url);
};
